import { PropertyTypes } from "../../app/property-types";
import { arrayAny } from "../../utils/arrayUtils";

export const PropertyTypeSelector = (props) => {

    const types = Object.entries(PropertyTypes).map(pt => pt[1]);

    const firstType = arrayAny(types) ? types[0] : null;

    return firstType ? (

        <div className="mb-3 d-md-flex fw-bold">
            <div className="dropdown-toggle">
                <div style={{ cursor: "pointer" }} data-bs-toggle="dropdown" className="text-decoration-none text-dark"><i className="fa fa-home fa-fw text-dark text-opacity-50 me-1"></i> {(props.selectedType ?? firstType).display} <b className="ms-5px caret"></b></div>

                <div className="dropdown-menu dropdown-menu-start">

                    {types.map(type => ( // For each type...
                        <div onClick={() => props.onTypeSelect(type)} style={{ cursor: "pointer" }} key={type.id} className="dropdown-item"><i className="fa fa-home fa-fw fa-lg text-gray-500 me-1"></i>{type.display}</div>

                    ))}

                </div>
            </div>
        </div>

    )
        :
        (<>Loading...</>);

};